<template>
  <div>
    <div class="row-payment-methods">
      <!--<div class="pre-label">Pasirinkite mokėjimo būdą:</div>-->
      <div
        v-for="type in paymentTypes"
        :key="type.id"
        class="payment-method"
        @click="selectPaymentMethod(type.id, type.handle)"
      >
        <div
          v-if="model.paymentMethod.type_id == type.id"
          class="active-payment-method"
        >
          <i class="fas fa-check-circle"></i>
        </div>

        <div class="method-logo" :class="type.handle">
          <img :src="`/images/Neopay.svg`" />
        </div>
        <div
          v-if="model.paymentMethod.type_id != 1"
          class="method-name"
          v-html="type.content"
        ></div>
      </div>
      <!-- Errors -->
      <div
        v-if="errorsShow && !model.paymentMethod.type_id"
        class="field-error field-error-payment-type"
      >
        Please select payment method
      </div>
      <!-- Errors end's -->
    </div>
    <div class="row-sub-payment-methods-divider"></div>
    <div class="row-sub-payment-methods">
      <div class="data-block-wrap">
        <div class="data-block-group">
          <transition name="fade" mode="out-in">
            <div :class="getSpinnerClass"></div>
          </transition>
          <transition name="fade" mode="out-in">
            <div v-if="loadingSubMethods" class="loading-text">
              Prašome palaukti ...
            </div>
          </transition>
          <div v-show="showSubTypes">
            <badger-accordion
              v-for="(subGroupType, sTId) in paymentSubTypes.payment_groups"
              :key="sTId"
              ref="myAccordion"
              :icons="icons"
              class="data-block-list-item data-block-list-item-accordion"
              refs="myAccordion"
            >
              <badger-accordion-item>
                <template slot="header">
                  <div class="header-title">
                    <span v-if="subGroupType.title" class="value-title">
                      {{ subGroupType.title }}
                    </span>
                  </div>
                </template>
                <template slot="content" class="data-block-item-content">
                  <div class="row-actions-holder"></div>
                  <div class="data-block-item-content-wrap">
                    <div
                      v-for="method in subGroupType.methods"
                      :key="method.key"
                      class="sub-payment-method"
                      :class="
                        model.paymentMethod.sub_type_id == method.key
                          ? 'active'
                          : ''
                      "
                      @click="selectSubPaymentMethod(method.key)"
                    >
                      <div class="sub-method-logo">
                        <img :src="method.logo_url" />
                      </div>
                      <div class="sub-method-name" v-html="method.title"></div>
                    </div>
                  </div>
                </template>
              </badger-accordion-item>
            </badger-accordion>
            <!-- Errors -->
            <div
              v-if="
                errorsShow &&
                paymentSubTypes &&
                paymentSubTypes.payment_groups &&
                !model.paymentMethod.sub_type_id &&
                !model.card.enabled
              "
              class="field-error field-error-payment-type"
            >
              Please select payment type
            </div>
            <!-- Errors end's -->
          </div>
        </div>
      </div>
    </div>
    <div class="row-sub-terms">
      <div class="form-group">
        <div class="form-check">
          <div class="custom-control custom-checkbox">
            <input
              id="check-terms"
              v-model="model.terms_agreed"
              type="checkbox"
              name="check-terms"
              class="custom-control-input"
            />
            <label for="check-terms" class="custom-control-label">
              Patvirtinu, kad perskaičiau ir sutinku su
              <!--              <a href="/terms-conditions" target="_blank">
                Terminai ir sąlygos
              </a>-->
              <a href="/privatumo-taisykles" target="_blank">
                Privatumo politika
              </a>
              .
              <!--              <a href="/conditions-of-purchase-and-sale" target="_blank">
                Conditions of Purchase and Sale
              </a>
              and
              <a href="/shipping-and-returns-policy" target="_blank">
                Shipping and Returns Policy
              </a>-->
            </label>
          </div>
        </div>
      </div>
      <!-- Errors -->
      <div
        v-if="errorsShow && !model.terms_agreed"
        class="field-error field-error-terms-agreed"
      >
        Turite patvirtinti, kad perskaitėte ir sutikote su visomis aukščiau
        nurodytomis sąlygomis.
      </div>
    </div>
  </div>
</template>

<script>
import { BadgerAccordion, BadgerAccordionItem } from 'vue-badger-accordion'
// import Multiselect from 'vue-multiselect'
export default {
  name: 'PaymentMethods',
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
  },
  data() {
    return {
      loadingSubMethods: false,
      showSubTypes: false,
      icons: {
        opened: '<i class="fas fa-chevron-up"></i>',
        closed: '<i class="fas fa-chevron-down"></i>',
      },
    }
  },
  computed: {
    getSpinnerClass() {
      return {
        spinnerPayment: this.loadingSubMethods,
      }
    },
    model() {
      return this.$store.getters['getData']
    },
    errorsShow() {
      return this.$store.getters['order/getShowErrors']
    },
    paymentTypes() {
      return this.$store.getters['getMethods']
    },
    paymentSubTypes() {
      return this.$store.getters['getSubMethods']
    },
    paymentsData() {
      return this.$store.getters['getPaymentsData']
    },
  },
  mounted() {
    this.$store.dispatch('getMethods', {})
  },
  methods: {
    selectPaymentMethod(id, handle) {
      if (handle == 'paysera') {
        this.paymentsData.payment_sub_methods = {}
        this.showSubTypes = false
        this.loadingSubMethods = true
        this.model.paymentMethod.type_id = id
        this.$store
          .dispatch('getPaymentMethodsSubTypes', {
            type_id: id,
            country_code: this.model.billingAddress.country_code,
          })
          .then((response) => {
            this.loadingSubMethods = false
            setTimeout(() => (this.showSubTypes = true), 700)
          })
          .catch((error) => {})
      } else {
        this.loadingSubMethods = true
        this.model.payment_sub_methods = {}
        this.model.paymentMethod.type_id = id
        this.loadingSubMethods = false
      }
    },
    selectSubPaymentMethod(id) {
      this.model.paymentMethod.sub_type_id = id
    },
  },
}
</script>
<style lang="css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
  will-change: opacity;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.spinnerPayment {
  height: 20px;
  width: 20px;
  margin-right: 8px;
  opacity: 1;
  filter: alpha(opacity=100);
  animation: rotation 0.7s infinite linear;
  border: 3px solid rgba(0, 0, 0, 0.2);
  border-top-color: #0094fc;
  border-radius: 100%;
  transition: 0.3s all ease;
  position: relative;
}
.loading-text {
  display: block;
  padding-left: 30px;
  margin-top: -18px;
  font-weight: 600;
  letter-spacing: 2px;
  position: relative;
  opacity: 0.2;
  filter: alpha(opacity=2);
  transition: 0.1s all ease;
}
</style>
